import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { CustomJrpcErrResult } from "../jsonRpc/jRpcErrResponse";

export type ConfirmEmailOtpRequest = {
    email: string,
    otp: string,
    locale: string
    current_entry_point: string
}

export type ConfirmEmailOtpResponse = {
    tether: {
        suid: string;
        token: string;
    };
};

export function confirmEmailOtp(data: ConfirmEmailOtpRequest): Promise<ConfirmEmailOtpResponse | CustomJrpcErrResult> {
    return HubJsonRpcRequest.makeRequest<ConfirmEmailOtpResponse, ConfirmEmailOtpRequest>(
        HubApiMethods.CONFIRM_EMAIL_OTP_AUTH,
        data,
        window.app.deviceIdentifier
    );
}
